import {useHistory} from "react-router-dom";
import {useEffect, useState} from "react";
import {Button, Card, Input, List, Select, Space, Table, Typography} from "antd";
import {t} from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";

export default function DoctorList()
{
    const history = useHistory();
    const [doctors, setDoctors] = useState([]);
    const [filteredData, setFilteredData] = useState([])

    const getDoctors = async () => {
        const res = await ApiService.Doctor.GetDoctorList({})

        if(res.success)
        {
            setDoctors(res.data)
        }
    }

    const deleteDoctor = async (doctorId) => {
        const res = await ApiService.Doctor.DeleteDoctor(doctorId);

        if(res.success)
        {
            await getDoctors();
        }
    }

    useEffect(() => {
        getDoctors()
    }, [])

    useEffect(() => {
        setFilteredData(doctors)
    }, [doctors])

    return (
        <SimpleLayout fullWidth={true}>
            <Card>
                <Space style={{marginBottom: 16}}>
                    <Button size={'small'} onClick={() => {history.push(`/app/system/doctors/create`)}} type={'primary'}>{t('New')}</Button>
                    <Button size={'small'} onClick={getDoctors}>{t('Refresh')}</Button>
                    <Input
                        size={'small'}
                        placeholder={t('Search')}
                        onChange={(e) => {
                            if(!e.target.value)
                            {
                                setFilteredData(doctors);
                                return
                            }
                            setFilteredData([...filteredData.filter(x => x.name.toLowerCase().includes(e.target.value.toLowerCase()))])
                        }}
                    />
                </Space>
                <Table
                    size={'small'}
                    dataSource={filteredData}
                    pagination={false}
                    columns={[
                        {dataIndex: 'name', key: 'name', title: t('Name')},
                        {dataIndex: 'units', key: 'units', title: t('Units'), render: (text, row) => row.units.map(x => x.name).join(', ')},
                        {dataIndex: '#', key: '#', title: t('#'), render: (text, row) => (
                                <Space>
                                    <a key="edit" href={`/app/system/doctors/edit/${row.id}`}>{t('edit')}</a>
                                    <a key="delete" onClick={async () => {await deleteDoctor(row.id)}} style={{color: 'red'}}>{t('Delete')}</a>
                                </Space>
                            )},
                    ]}
                />
            </Card>
        </SimpleLayout>
    )
}